export const rangeHighToString = (rangeHigh: number, maxRange: number, short: boolean = false, altString: string = '') => {
  if (rangeHigh > maxRange) {
    return short ? 'Ultd' : 'Unlimited';
  } else if (altString.length > 0) {
    return altString;
  }
  return rangeHigh.toString();
};
